import React from 'react';

interface DosageTableProps {
  concentration: string;
  targetDosage: string;
  medicationType?: 'tirzepatide' | 'semaglutide';
}

const TIRZEPATIDE_DOSAGES = [2.5, 5, 7.5, 10, 12.5, 15];
const SEMAGLUTIDE_DOSAGES = [0.25, 0.5, 1, 1.7, 2, 2.4];

const DosageTable: React.FC<DosageTableProps> = ({ concentration, targetDosage, medicationType = 'tirzepatide' }) => {
  const dosages = medicationType === 'tirzepatide' ? TIRZEPATIDE_DOSAGES : SEMAGLUTIDE_DOSAGES;
  const targetDosageNum = parseFloat(targetDosage);

  // Add targetDosage to the array if it's not already included and it's a valid number
  const allDosages =
    !isNaN(targetDosageNum) && !dosages.includes(targetDosageNum)
      ? [...dosages, targetDosageNum].sort((a, b) => a - b)
      : dosages;

  return (
    <div>
      <h3>
        FatScientist.com {concentration}mg/mL Concentration
        <br /> {medicationType === 'tirzepatide' ? 'Tirzepatide' : 'Semaglutide'} Dosage Cheat Sheet
      </h3>
      <table>
        <thead>
          <tr>
            <th>Dosage (mg)</th>
            <th>Units</th>
          </tr>
        </thead>
        <tbody>
          {allDosages.map(dosage => (
            <tr
              key={dosage}
              style={{
                backgroundColor: allDosages.indexOf(dosage) % 2 === 0 ? '#e6ffe6' : 'white',
                fontWeight: dosage === targetDosageNum ? 'bold' : 'normal',
              }}
            >
              <td>{dosage}mg</td>
              <td>{Math.round((dosage / parseFloat(concentration)) * 100)} units</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DosageTable;
